import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/campaigns/_layout")({
  component: CampaignLayout,
});

function CampaignLayout() {
  return (
    <div className="min-h-screen bg-secondary dark:bg-black">
      <Outlet />
    </div>
  );
}
